import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";
import { persistAuthSession } from "utils/persistAuthSession";
import { useUrlQuery } from "hooks/useUrlQuery";

const useRegister = () => {
	const history = useHistory();

	const queryClient = useQueryClient();
	const query = useUrlQuery();
	const { accessToken } = useTokenStore();

	const register = async (obj) => {
		const instance = await InitApi({ accessToken }, "multipart/form-data");

		const body = deleteEmptyObjects(obj);

		const formData = new FormData();
		Object.keys(body).forEach((key) => {
			formData.append(key, body[key]);
		});
		const response = await instance.post("/auth/register", formData);
		return { ...response, plainPassword: body?.password };
	};

	return useMutation(register, {
		onSuccess: async ({ data: body }) => {
			persistAuthSession(body, { queryClient, history, intended: query.get("intended") });
		},
		onError: async ({ response }) => {
			toast.error(
				<ServerErrors
					errorMessage={response?.data?.message || "Unable to register. Please try again."}
					errors={response?.data?.data}
				/>
			);
		},
	});
};

export default useRegister;
